export default __webpack_public_path__ + "static/media/reward-9.ed981b7d.png";